angular.module('bizmetryApp').controller('AgentDetailsDialogController', function (
    $scope, $mdDialog, $interval, $mdToast,
    agent, profileId, accountId, refreshIntervalMs,
    getEnvironmentTypeLabel, formatSyncTime, getLogPressureColor,
    restartAgent, openDownloadDialog,
    TelemetryAgentService
) {
    $scope.agent = agent;
    $scope.openDownloadDialog = openDownloadDialog;
    $scope.profileId = profileId;
    $scope.accountId = accountId;
    $scope.getEnvironmentTypeLabel = getEnvironmentTypeLabel;
    $scope.formatSyncTime = formatSyncTime;
    $scope.getLogPressureColor = getLogPressureColor;

    // Redondea a 1 decimal antes de pasar por el filtro bmCompactNumber —
    // ese filtro no redondea su rama "< 10000" (String(n) tal cual), y
    // avgIngestedFramesPerMin es un cociente (sum/window) que puede traer
    // muchos decimales de punto flotante.
    $scope.round1 = function (value) {
        return Math.round((value || 0) * 10) / 10;
    };

    // SAF upload tiles — mismo formato que las del interceptor
    // (EnvironmentStatusDialogController); null = sin telemetría → "—".
    function missing(value) { return value === null || value === undefined; }
    $scope.frameRateLabel = function (value) {
        return missing(value) ? '—' : value.toFixed(1) + '/min';
    };
    $scope.kbRateLabel = function (value) {
        return missing(value) ? '—' : value.toFixed(1) + ' KB/min';
    };
    $scope.batchSizeLabel = function (value) {
        return missing(value) ? '—' : Math.round(value);
    };
    // Trend arrow for Load Pressure / Hogging Rate — same as the interceptor dialogs:
    // UP (worse) red arrow_upward, DOWN green arrow_downward, FLAT/UNKNOWN none.
    $scope.trendIcon = function (trend) {
        if (trend === 'UP') { return 'arrow_upward'; }
        if (trend === 'DOWN') { return 'arrow_downward'; }
        return null;
    };
    $scope.percentLabel = function (value) {
        return missing(value) ? '—' : Math.round(value) + '%';
    };

    // ========================================
    // INSTANCIAS (HA) — "Todas las instancias" vs una puntual
    // ========================================

    $scope.instances = [];
    $scope.selectedPodName = null; // solo para mostrar — ver selectedPodUid
    $scope.selectedPodUid = null; // null = "Agent" (agregado del backend) — clave real de
    // selección: podName solo NO alcanza, un pod reemplazado por un restart
    // convive un rato con el viejo bajo el MISMO podName (distinto podUid,
    // ver AgentInstance#findOrCreate en el backend) y matchear por podName
    // hacía que ambas filas resolvieran a la misma instancia.

    function refreshInstances() {
        TelemetryAgentService.getAgentInstances($scope.agent.agentId, $scope.accountId)
            .then(function (response) {
                $scope.instances = response.data || [];
                // si la instancia seleccionada ya no existe (p.ej. se purgó), volver a "Agent"
                if ($scope.selectedPodUid &&
                    !$scope.instances.some(function (i) { return i.podUid === $scope.selectedPodUid; })) {
                    $scope.selectedPodName = null;
                    $scope.selectedPodUid = null;
                }
            })
            .catch(function (error) {
                console.warn('AgentDetails: error refreshing instances', error);
            });
    }

    // Objeto del que el bloque "Performance Metrics" lee sus valores: el
    // agente (agregado real, calculado server-side) cuando no hay instancia
    // puntual seleccionada, o la instancia elegida en caso contrario — mismo
    // shape en ambos casos (avg/min/max{Cpu,Mem}Usage, pingLatency/min/maxLatency,
    // logPressure), así que el template no necesita duplicar markup.
    $scope.getDisplayMetrics = function () {
        if (!$scope.selectedPodUid) {
            return $scope.agent;
        }
        return $scope.instances.find(function (i) { return i.podUid === $scope.selectedPodUid; }) || $scope.agent;
    };

    // agentSafForwarderMaxCount es el techo POR POD (mismo config en cada
    // réplica) — el numerador de la tile "SAF Forwarder Count" ya viene sumado
    // entre pods a nivel general (ver TelemetryAgent#activeSafForwarderCount en
    // agent-management-microservice), así que el denominador tiene que escalar
    // igual acá para que el ratio sea real: sin pod seleccionado, multiplica el
    // techo por instanceCount (cantidad de pods RUNNING); con un pod puntual
    // seleccionado, es solo el techo de ESE pod.
    $scope.getSafForwarderMaxForDisplay = function () {
        var perPodMax = $scope.agent && $scope.agent.agentSafForwarderMaxCount;
        if (!perPodMax) { return 0; }
        if ($scope.selectedPodUid) { return perPodMax; }
        var instanceCount = $scope.agent.instanceCount || 1;
        return perPodMax * instanceCount;
    };

    $scope.selectInstance = function (podName, podUid) {
        $scope.selectedPodName = podName;
        $scope.selectedPodUid = podUid || null;
    };

    refreshInstances();

    // ========================================
    // REFRESH PERIÓDICO
    //
    // Ciclo de vida:
    //   dialog abierto  → startRefresh()
    //   cualquier cierre → $destroy → stopRefresh()
    //       - closeDialog() llama $mdDialog.hide() → $destroy
    //       - Escape / click fuera               → $destroy
    // ========================================

    var refreshTimer = null;

    function refreshAgent() {
        // ✅ Usar getAgentById - más eficiente que traer todos los agentes
        TelemetryAgentService.getAgentById($scope.agent.agentId, $scope.accountId)
            .then(function (response) {
                // In-place para que los bindings de Angular detecten los cambios
                angular.extend($scope.agent, response.data);
            })
            .catch(function (error) {
                console.warn('AgentDetails: error refreshing agent', error);

                // Si el agente fue eliminado (404), cerrar el dialog
                if (error.status === 404) {
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent('Agent no longer exists')
                            .position('top right')
                            .hideDelay(3000)
                    );
                    $scope.closeDialog();
                }
            });

        refreshInstances();
    }

    function startRefresh() {
        if (refreshIntervalMs && refreshIntervalMs > 0) {
            refreshTimer = $interval(refreshAgent, refreshIntervalMs);
        }
    }

    function stopRefresh() {
        if (refreshTimer) {
            $interval.cancel(refreshTimer);
            refreshTimer = null;
        }
    }

    // Iniciar refresh al abrir el dialog
    startRefresh();

    // Destruir refresh en cualquier forma de cierre del dialog
    $scope.$on('$destroy', function () {
        stopRefresh();
    });

    // ========================================
    // CLOSE
    // ========================================

    $scope.closeDialog = function () {
        // stopRefresh() aquí es redundante ($destroy lo hace siempre),
        // pero lo dejamos para que el timer no corra durante la animación de cierre.
        stopRefresh();
        $mdDialog.hide();
    };

    // ========================================
    // COPY AGENT ID
    // ========================================

    $scope.copyAgentId = function (agentId) {
        var textarea = document.createElement('textarea');
        textarea.value = agentId;
        textarea.style.position = 'fixed';
        textarea.style.opacity = '0';
        document.body.appendChild(textarea);
        textarea.select();

        try {
            document.execCommand('copy');
            $mdToast.show($mdToast.simple().textContent('Agent ID copied to clipboard').position('top right').hideDelay(2000));
        } catch (e) {
            $mdToast.show($mdToast.simple().textContent('Could not copy to clipboard').position('top right').hideDelay(2000));
        } finally {
            document.body.removeChild(textarea);
        }
    };

    // agent.upTime es una duración en ms (no timestamp) — <bm-duration>
    // espera un "since" (epoch), lo convertimos acá para que el formato
    // días/horas/minutos sea consistente con el resto de la app.
    //
    // Memoizado por valor de entrada: bm-duration usa esto como binding
    // one-way ("since='<'"), y Angular lo re-evalúa en cada digest para
    // detectar cambios. Si devolviera Date.now() - uptimeMs sin cachear,
    // el resultado difiere en ~1ms cada vez que se llama — dos chequeos
    // consecutivos del MISMO digest nunca coinciden, y Angular tira
    // $rootScope:infdig (digest infinito) tras 10 iteraciones.
    var uptimeSinceCache = {};
    $scope.uptimeSince = function (uptimeMs) {
        if (!uptimeMs) return null;
        if (!(uptimeMs in uptimeSinceCache)) {
            uptimeSinceCache[uptimeMs] = Date.now() - uptimeMs;
        }
        return uptimeSinceCache[uptimeMs];
    };

    $scope.restartAgent = function (agent) {
        restartAgent(agent);
        // Opcional: cerrar el details dialog cuando se confirme el restart
        // $mdDialog.hide();
    };

    // ========================================
    // MONITORING ALERTS
    // ========================================

    $scope.isMonitoringSet = function (metric) {
        if (!$scope.agent || !$scope.agent.monitoringConfig) return false;
        var metricConfig = $scope.agent.monitoringConfig[metric];
        if (!metricConfig || !metricConfig.enabled) return false;
        return metricConfig.status === 'SET_CONDITION';
    };

    $scope.hasMonitoringAlerts = function () {
        // Was `$(scope.agent…` — a ReferenceError on every digest, so the SLA
        // Breaches empty state (ng-if="!hasMonitoringAlerts()") never rendered.
        if (!$scope.agent || ($scope.agent.agentStatus !== 'ONLINE' && $scope.agent.agentStatus !== 'STALLED')) return false;
        return $scope.isMonitoringSet('cpu') ||
            $scope.isMonitoringSet('memory') ||
            $scope.isMonitoringSet('latency') ||
            $scope.isMonitoringSet('pressure');
    };

    $scope.stripPort = function (host) {
        if (!host) return null;
        var lastColon = host.lastIndexOf(':');
        if (lastColon !== -1 && /^\d+$/.test(host.substring(lastColon + 1))) {
            return host.substring(0, lastColon);
        }
        return host;
    };

});